(ns common.schema.entities.holding.schema
  (:require
   [common.country :as country]
   [common.currencies :as currencies]
   [common.holding-exit-status :as exit-statuses]
   [common.schema.constraints :as constraints]
   [common.schema.entities.common :as common-schema]
   [common.schema.option-filters :as option-filters]
   [common.schema.schema-utils :as su]
   [common.util :as cu]))

(def schema
  (vec
   (concat
    [[:holding/name
      {:field/data-type             :data.type/text-simple
       :field/name-attribute        :holding/name
       :field/mandatory             :mandatory/always
       :field/system-required?      true
       :field/system-semantics      su/user-provided-system-required-field-semantics

       :field/default-visibility    {:editor :editor.type/none
                                     :grid   :editor.type/text-simple
                                     :filter :filter.type/text
                                     :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/lower-case-str?       true
       :field/not-clearable?        true
       :field/translations          {:en "Name"}
       :field/constraints           {:constraint/string-min-length         1
                                     :constraint/unique-tenant-ignore-case
                                     {:validation-fn (partial constraints/tenant-unique-ignore-case
                                                              :holding/name
                                                              [:entity.type/holding])}}}]
     [:holding/owner
      {:field/data-type          :data.type/ref-single
       :field/not-clearable?     true
       :value-type               :entity
       :field/entity-types       [:entity.type/account]
       :field/default-visibility {:editor :editor.type/select
                                  :grid   :editor.type/select
                                  :filter :filter.type/select
                                  :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations       {:en "Owner"}
       :field/option-filter-fn   option-filters/active-users
       :field/os-filter-terms-fn    (fn [{:keys [] :as args}]
                                      {"extras.active-user" true})}]

     [:holding/target-asset
      {:field/data-type          :data.type/ref-single
       :value-type               :entity
       :create-on-fly?           true
       :field/entity-types       [:entity.type/asset]
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/link
                                  :filter :filter.type/text
                                  :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations       {:en "Target asset"}}]

     [:holding/priority
      {:field/data-type          :data.type/integer
       :field/constraints        {:constraint/number-positive        true
                                  :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility {:editor :editor.type/integer
                                  :grid   :editor.type/integer
                                  :filter :filter.type/integer
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations       {:en "Priority"}}]

     [:holding/cur-paid-in-capital
      {:field/data-type             :data.type/currency-value
       :field/short-name            {:en "Invested"}
       :field/aggregate-total-fn    su/agg-sum
       :field/secondary-attribute   :holding/cur-paid-in-capital--sym
       :field/constraints           {:constraint/number-positive        true
                                     :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility    {:editor :editor.type/number
                                     :grid   :editor.type/number
                                     :filter :filter.type/number
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Paid in capital"}}]

     [:holding/cur-paid-in-capital--sym
      {:field/data-type :data.type/currency-symbol
       :value-type :keyword
       :field/related-fields :holding/cur-paid-in-capital
       :field/default-visibility {:editor :editor.type/select
                                  :grid   :editor.type/select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations {:en "Paid in capital (currency)"}
       :field/secondary-field? true
       :field/not-clearable? true
       :options currencies/options}]

     [:holding/cur-distributions
      {:field/data-type           :data.type/currency-value
       :field/secondary-attribute :holding/cur-distributions--sym
       :field/constraints         {:constraint/number-positive        true
                                   :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility  {:editor :editor.type/number
                                   :grid   :editor.type/number
                                   :filter :filter.type/number
                                   :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations        {:en "Distributions"}}]

     [:holding/cur-distributions--sym
      {:field/data-type :data.type/currency-symbol
       :value-type :keyword
       :field/related-fields :holding/cur-distributions
       :field/default-visibility {:editor :editor.type/select
                                  :grid   :editor.type/select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations {:en "Distributions (currency)"}
       :field/secondary-field? true
       :field/not-clearable? true
       :options currencies/options}]

     [:holding/cur-residual-value
      {:field/data-type           :data.type/currency-value
       :field/secondary-attribute :holding/cur-residual-value--sym
       :field/constraints         {:constraint/number-positive        true
                                   :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility  {:editor :editor.type/number
                                   :grid   :editor.type/number
                                   :filter :filter.type/number
                                   :field-visibility :in-use}
       :field/default-authorization {:access/read :role/user :access/write :role/user}
       :field/translations        {:en "Residual value"}}]

     [:holding/cur-residual-value--sym
      {:field/data-type :data.type/currency-symbol
       :value-type :keyword
       :field/related-fields :holding/cur-residual-value
       :field/default-visibility {:editor :editor.type/select
                                  :grid   :editor.type/select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations {:en "Residual value (currency)"}
       :field/secondary-field? true
       :field/not-clearable? true
       :options currencies/options}]

     [:holding/exit-plan
      {:field/data-type          :data.type/text-multiline
       :field/default-visibility {:editor :editor.type/textarea
                                  :grid   :editor.type/textarea
                                  :filter :filter.type/text
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations       {:en "Exit plan"}}]

     [:holding/recent-status
      {:field/data-type          :data.type/text-multiline
       :field/default-visibility {:editor :editor.type/textarea
                                  :grid   :editor.type/textarea
                                  :filter :filter.type/text
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations       {:en "Recent status"}}]

     [:holding/exit-status
      {:field/data-type :data.type/keyword
       :value-type :keyword
       :field/default-visibility {:editor :editor.type/select
                                  :grid   :editor.type/select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/not-clearable? true
       :field/translations {:en "Exit status"}
       :options exit-statuses/options}]

     [:holding/tag-tags
      {:field/data-type          :data.type/ref-multi
       :value-type               :entity
       :create-on-fly?           true
       :field/entity-types       [:entity.type/named-value]
       :named-value-attribute    :holding/tag-tags
       :field/default-visibility {:editor :editor.type/multi-select
                                  :grid   :editor.type/multi-select
                                  :filter :filter.type/select
                                  :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations       {:en "Holding tags"}}]
     common-schema/team-members-field
     common-schema/common-network-drive-field]
    common-schema/common-network-drives-field
    common-schema/common-folders-path
    (su/currency-field :holding/cur-valuation "Valuation" {:default-field-visibility :in-use})
    (su/currency-field :holding/cur-value-creation-since-investment
                       "Value creation since investment"
                       {:default-field-visibility :in-use})
    (su/text-multiline-field :holding/valuation-comment
                             "Valuation comment"
                             {:default-field-visibility :in-use})
    (su/text-multiline-field :holding/trading-and-financial-overview
                             "Trading and financial overview"
                             {})

    (su/single-ref-field :holding/fund
                         "Our fund"
                         [:entity.type/fund]
                         {:field/default-visibility {:editor :editor.type/none
                                                     :grid   :editor.type/link
                                                     :filter :filter.type/select
                                                     :field-visibility :in-use}
                          :field-in-use-filter      su/fund-field-in-use?})
    (su/currency-field :holding/cur-fair-value "Fair value" {:default-field-visibility :in-use})
    (su/currency-field :holding/cur-IGP-last-known-cash-balance
                       "Last known cash balance"
                       {:default-field-visibility :not-in-use-blocked})
    (su/currency-field :holding/cur-IGP-last-known-budgeted-MRR
                       "Last known budgeted MRR"
                       {:default-field-visibility :not-in-use-blocked})
    (su/currency-field :holding/cur-IGP-last-known-actual-MRR
                       "Last known actual MRR"
                       {:default-field-visibility :not-in-use-blocked})
    (su/currency-field :holding/cur-paid-in-equity "Paid in equity" {})
    (su/currency-field :holding/cur-paid-in-loan "Paid in loan" {})
    (su/option-field :holding/holding-stage "Stage" {})
    (su/integer-field :holding/number-of-female-team-members
                      "Number of female team members"
                      {:default-field-visibility :not-in-use-blocked})
    (su/integer-field :holding/number-of-male-team-members
                      "Number of male team members"
                      {:default-field-visibility :not-in-use-blocked})
    (su/date-field :holding/date-IC-approval "IC Approval" {})
    (su/date-field :holding/date-CIC-approval
                   "CIC Approval"
                   {:default-field-visibility :not-in-use-blocked})
    (su/option-field :holding/business-unit "Business unit" {})
    (su/option-field-multi :holding/tag-holding-type "Holding type" {})
    (su/keyword-field :holding/country "Country" country/options {})
    (su/option-field-multi :holding/target-markets "Target markets" {})
    (su/option-field :holding/sector "Sector" {})
    (su/option-field-multi :holding/sectors "Sectors" {})
    (su/option-field :holding/segment "Segment" {})
    (su/option-field-multi :holding/segments "Segments" {})
    (su/option-field-multi :holding/tag-deal-type
                           "Deal type"
                           {:default-field-visibility :not-in-use-blocked})
    (su/currency-field :holding/cur-ALJ-equity-ticket-size
                       "ALJ equity ticket size"
                       {:default-field-visibility :not-in-use-blocked})
    (su/percentage-field :holding/net-irr "NET IRR" {})
    (su/date-field :holding/date-CIC-presentation
                   "CIC presentation"
                   {:default-field-visibility :not-in-use-blocked})
    (su/option-field :holding/SBDI-POC "SBDI POC" {:default-field-visibility :not-in-use-blocked})
    (su/text-multiline-field :holding/description "Description" {:default-field-visibility :in-use})
    (su/integer-field :holding/year-of-entry
                      "Year of entry"
                      {:default-field-visibility :not-in-use})
    (su/option-field :holding/overall-company-performance
                     "Overall company performance"
                     {:default-field-visibility :not-in-use})
    (su/option-field :holding/overall-position-thuja
                     "Overall position Thuja"
                     {:default-field-visibility :not-in-use-blocked})
    (su/option-field-multi :holding/regulatory-class
                           "Regulatory class"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :holding/therapeutic-class
                           "Therapeutic class"
                           {:default-field-visibility :not-in-use})
    (su/option-field-multi :holding/advisory-board-seats
                           "Advisory board seats"
                           {:default-field-visibility :not-in-use-blocked})
    (su/option-field :holding/stock-exchange-of-a-listed-company
                     "Stock exchange of a listed company"
                     {:default-field-visibility :not-in-use-blocked})
    (su/option-field-multi :holding/advisory-board-tesi
                           "Advisory board Tesi"
                           {:default-field-visibility :not-in-use-blocked})
    (su/option-field-multi :holding/advisory-board-krr
                           "Advisory board KRR"
                           {:default-field-visibility :not-in-use-blocked})

    (su/date-field :holding/entry-date
                   "Entry date"
                   {:default-field-visibility :not-in-use
                    :short-name "Date"})
    (su/percentage-field :holding/stake-percentage
                         "Ownership %"
                         {:default-field-visibility :not-in-use
                          :short-name "%"})
    (su/currency-field :holding/cur-expected-add-ons
                       "Expected add-ons"
                       {:default-field-visibility :not-in-use
                        :short-name "Add-on"})
    (su/option-field :holding/deal-type "Deal type" {:default-field-visibility :not-in-use})
    (su/currency-field :holding/cur-realized-gains
                       "Realized gains"
                       {:default-field-visibility :not-in-use
                        :short-name "Realized"})
    (su/currency-field :holding/cur-book-value
                       "Book value"
                       {:default-field-visibility :not-in-use
                        :short-name "BV"})

    (su/currency-field :holding/cur-target-company-exit-value
                       "Target company EV"
                       {:default-field-visibility :not-in-use})
    (su/currency-field :holding/cur-target-exit-value
                       "Target exit value"
                       {:default-field-visibility :not-in-use
                        :short-name "Exit value"})
    (su/currency-field :holding/cur-upside "Upside" {:default-field-visibility :not-in-use})
    (su/text-multiline-field :holding/comment "Comments" {:default-field-visibility :not-in-use})
    (su/text-multiline-field :holding/action-items
                             "Action items"
                             {:default-field-visibility :not-in-use})

    [[:holding/expected-total-investment
      {:field/data-type             :data.type/currency-value
       :field/aggregate-total-fn    su/agg-sum
       ;; The add-ons can be blank, so the paid-in capital gives the currency label.
       :field/secondary-attribute   :holding/cur-paid-in-capital--sym
       :field/default-visibility    {:editor :editor.type/number
                                     :grid   :editor.type/number
                                     :filter :filter.type/number
                                     :field-visibility :not-in-use}
       :field/composite-attributes  [:holding/cur-paid-in-capital
                                     :holding/cur-expected-add-ons]
       :field/calculated-field      (fn [{:keys [logger show-errors? entity-data entity-lookup tr
                                                 float->bigdec bigdec->float get-field-schema
                                                 display-string]}]
                                      (let [expected-add-ons (bigdec->float
                                                              (:holding/cur-expected-add-ons
                                                               entity-data))
                                            paid-in-capital (bigdec->float
                                                             (:holding/cur-paid-in-capital
                                                              entity-data))]
                                        ;; Blank add-ons count as 0 (DEV-8225). The currency
                                        ;; check compares only the inputs that have a value.
                                        (cond
                                          (not (number? paid-in-capital))
                                          (when show-errors?
                                            (tr :not-a-number
                                                [(tr :holding/cur-paid-in-capital)]))
                                          (and (number? expected-add-ons)
                                               (not (= (:holding/cur-expected-add-ons--sym entity-data)
                                                       (:holding/cur-paid-in-capital--sym entity-data))))
                                          (when show-errors?
                                            (tr :not-same-currency
                                                [(str (tr :holding/cur-expected-add-ons)
                                                      ", "
                                                      (tr :holding/cur-paid-in-capital))]))
                                          :else
                                          (float->bigdec (+ (or expected-add-ons 0) paid-in-capital)))))
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/system}
       :field/custom-params         (fn [_]
                                      {:base-multiplier nil})
       :field/short-name            {:en "Total investment"}
       :field/translations          {:en "Expected total investment"}}]
     [:holding/realized-gains-and-book-value
      {:field/data-type             :data.type/currency-value
       :field/aggregate-total-fn    su/agg-sum
       :field/secondary-attribute   :holding/cur-book-value--sym
       :field/default-visibility    {:editor :editor.type/number
                                     :grid   :editor.type/number
                                     :filter :filter.type/number
                                     :field-visibility :not-in-use}
       :field/composite-attributes  [:holding/cur-realized-gains
                                     :holding/cur-book-value]
       :field/calculated-field      (fn [{:keys [logger show-errors? entity-data entity-lookup tr
                                                 bigdec->float float->bigdec get-field-schema
                                                 display-string]}]
                                      (let [realized-gains (bigdec->float
                                                            (:holding/cur-realized-gains
                                                             entity-data))
                                            book-value (bigdec->float (:holding/cur-book-value
                                                                       entity-data))]
                                        (cond
                                          (not (number? realized-gains))
                                          (when show-errors?
                                            (tr :not-a-number
                                                [(tr :holding/cur-realized-gains)]))
                                          (not (number? book-value))
                                          (when show-errors?
                                            (tr :not-a-number [(tr :holding/cur-book-value)]))
                                          (not (= (:holding/cur-book-value--sym entity-data)
                                                  (:holding/cur-realized-gains--sym entity-data)))
                                          (when show-errors?
                                            (tr :not-same-currency
                                                [(str (tr :holding/cur-realized-gains)
                                                      ", "
                                                      (tr :holding/cur-book-value))]))
                                          :else
                                          (float->bigdec (+ realized-gains book-value)))))
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/system}
       :field/custom-params         (fn [_]
                                      {:base-multiplier nil})
       :field/short-name            {:en "Total value"}
       :field/translations          {:en "Current total value"}}]

     [:holding/gross-multiple
      {:field/data-type             :data.type/multiplier
       :field/aggregate-total-fn    su/agg-avg-skip-empty
       :field/default-visibility    {:editor :editor.type/multiplier
                                     :grid   :editor.type/multiplier
                                     :filter :filter.type/multiplier
                                     :field-visibility :not-in-use}
       :field/composite-attributes  [:holding/cur-realized-gains
                                     :holding/cur-total-gains]
       :field/calculated-field
       (fn [{:keys [logger show-errors? entity-data entity-lookup tr float->bigdec bigdec->float
                    get-field-schema display-string]}]
         (let [distributions (bigdec->float (:holding/cur-distributions entity-data))
               residual-value (bigdec->float (:holding/cur-residual-value entity-data))
               paid-in-capital (bigdec->float (:holding/cur-paid-in-capital entity-data))]
           (cond
             (not (number? distributions))
             (when show-errors?
               (tr :not-a-number [(tr :holding/cur-distributions)]))
             (not (number? residual-value))
             (when show-errors?
               (tr :not-a-number [(tr :holding/cur-residual-value)]))
             (not (number? paid-in-capital))
             (when show-errors?
               (tr :not-a-number [(tr :holding/cur-paid-in-capital)]))
             (not (= (:holding/cur-distributions--sym entity-data)
                     (:holding/cur-residual-value--sym entity-data)
                     (:holding/cur-paid-in-capital--sym entity-data)))
             (when show-errors?
               (tr :not-same-currency
                   [(str (tr :holding/cur-distributions)
                         ", "
                         (tr :holding/cur-residual-value)
                         ", "
                         (tr :holding/cur-paid-in-capital))]))
             :else
             (let [dividend (+ distributions residual-value)
                   divider paid-in-capital]
               ;; A number, as the data type says. A divider of zero gives no multiple.
               (when-not (zero? divider)
                 (/ dividend divider))))))
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/system}
       :field/custom-params         (fn [_]
                                      {:base-multiplier "1"})
       :field/translations          {:en "Gross multiple"}}]
     [:holding/expected-multiple
      {:field/data-type             :data.type/multiplier
       :field/aggregate-total-fn    su/avg-mult
       :field/default-visibility    {:editor :editor.type/multiplier
                                     :grid   :editor.type/multiplier
                                     :filter :filter.type/multiplier
                                     :field-visibility :not-in-use}
       :field/composite-attributes  [:holding/cur-target-exit-value
                                     :holding/cur-paid-in-capital
                                     :holding/cur-expected-add-ons]
       :field/calculated-field
       (fn [{:keys [logger show-errors? entity-data entity-lookup tr bigdec->float get-field-schema
                    display-string]}]
         (let [target-exit (bigdec->float (:holding/cur-target-exit-value entity-data))
               expected-add-ons (bigdec->float (:holding/cur-expected-add-ons entity-data))
               paid-in-capital (bigdec->float (:holding/cur-paid-in-capital entity-data))]
           ;; Blank add-ons count as 0 (DEV-8225). The currency check compares only the
           ;; inputs that have a value.
           (cond
             (not (number? target-exit))
             (when show-errors?
               (tr :not-a-number [(tr :holding/cur-target-exit-value)]))
             (not (number? paid-in-capital))
             (when show-errors?
               (tr :not-a-number [(tr :holding/cur-paid-in-capital)]))
             (not (apply = (cond-> [(:holding/cur-target-exit-value--sym entity-data)
                                    (:holding/cur-paid-in-capital--sym entity-data)]
                             (number? expected-add-ons)
                             (conj (:holding/cur-expected-add-ons--sym entity-data)))))
             (when show-errors?
               (tr :not-same-currency
                   [(str (tr :holding/cur-target-exit-value)
                         (when (number? expected-add-ons)
                           (str ", " (tr :holding/cur-expected-add-ons)))
                         ", "
                         (tr :holding/cur-paid-in-capital))]))
             :else
             (let [dividend target-exit
                   divider (+ (or expected-add-ons 0) paid-in-capital)]
               ;; A number, as the data type says. A divider of zero gives no multiple.
               (when-not (zero? divider)
                 (/ dividend divider))))))
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/system}
       :field/custom-params         (fn [_]
                                      {:base-multiplier "1"})
       :field/short-name            {:en "Multiple"}
       :field/translations          {:en "Expected multiple"}}]]

    (su/option-field :holding/priority-level
                     "Priority Level"
                     {:default-field-visibility :not-in-use})
    (su/currency-field :holding/cur-sanctioned
                       "Sanctioned"
                       {:default-field-visibility :not-in-use})
    (su/currency-field :holding/cur-repayments
                       "Repayments"
                       {:default-field-visibility :not-in-use})
    (su/currency-field :holding/cur-outstanding-debt
                       "Outstanding debt"
                       {:default-field-visibility :not-in-use})
    (su/currency-field :holding/cur-warrants-or-equity-outstanding
                       "Warrants or equity outstanding"
                       {:default-field-visibility :not-in-use})
    (su/currency-field :holding/cur-equity-uninvested-positions
                       "Equity uninvested positions"
                       {:default-field-visibility :not-in-use})
    (su/text-multiline-field :holding/tenor-description
                             "Tenor"
                             {:default-field-visibility :not-in-use})
    (su/date-field :holding/maturity-date
                   "Maturity date"
                   {:default-field-visibility :not-in-use})
    (su/percentage-field :holding/upfront-pct
                         "Upfront %"
                         {:default-field-visibility :not-in-use})
    (su/percentage-field :holding/coupon-pct
                         "Coupon %"
                         {:default-field-visibility :not-in-use})
    (su/percentage-field :holding/redemption-pct
                         "Redemption %"
                         {:default-field-visibility :not-in-use})

    (su/multi-ref-field :holding/risks
                        "Risks"
                        [:entity.type/risk-holding]
                        {:authorization    su/access-user-user
                         :editor-type      :editor.type/none
                         :grid-type        :editor.type/none
                         :filter-type      :filter.type/boolean
                         :required-modules [:module/risk-module]}))))
